import { createRoot } from "react-dom/client";
import { registerSW } from "virtual:pwa-register";
import App from "./App.tsx";
import { shouldDisableServiceWorker, unregisterServiceWorkers } from "@/lib/pwa";
import "./index.css";

if (typeof window !== "undefined" && "serviceWorker" in navigator) {
  if (shouldDisableServiceWorker()) {
    void unregisterServiceWorkers().catch(() => undefined);
  } else if (import.meta.env.PROD) {
    const updateSW = registerSW({
      immediate: true,
      onNeedRefresh() {
        // New content available — reload immediately for seamless updates
        updateSW(true);
      },
      onRegisteredSW(swUrl, registration) {
        // Poll for SW updates every 60 seconds so installed PWAs get new builds fast
        if (registration) {
          setInterval(() => {
            registration.update();
          }, 60 * 1000);
        }
      },
    });

    // Also re-register with updateViaCache: 'none' so browser never
    // serves a stale sw.js from HTTP cache on installed PWAs / APKs
    navigator.serviceWorker
      .getRegistration()
      .then((reg) => {
        if (!reg) {
          navigator.serviceWorker.register("/sw.js", {
            updateViaCache: "none",
          });
        }
      })
      .catch(() => {});
  }
}

createRoot(document.getElementById("root")!).render(<App />);
